import React from 'react';
import InflationCalculator from '../components/calculators/InflationCalculator';
import FAQ from '../components/FAQ';
import SEO from '../components/shared/SEO';

const InflationPage: React.FC = () => {
  const faqs = [
    {
      question: "What is inflation?",
      answer: "Inflation is the rate at which the general level of prices for goods and services rises, subsequently causing purchasing power to fall over time."
    },
    {
      question: "How does inflation affect my savings?",
      answer: "Inflation erodes the purchasing power of your money over time. For example, $100 today will buy less in the future due to rising prices."
    },
    {
      question: "What is a normal inflation rate?",
      answer: "In the United States, the Federal Reserve targets an average inflation rate of 2% over time, though actual rates can vary significantly."
    },
    {
      question: "How can I protect against inflation?",
      answer: "Common strategies include investing in stocks, real estate, inflation-protected securities (TIPS), and maintaining a diversified investment portfolio."
    },
    {
      question: "What factors influence inflation?",
      answer: "Inflation can be influenced by monetary policy, government spending, supply chain issues, economic growth, and global economic conditions."
    }
  ];

  return (
    <>
      <SEO 
        title="Inflation Impact Calculator"
        description="Calculate the impact of inflation on your money's purchasing power. Project future values and plan for inflation effects."
        keywords={[
          'inflation calculator',
          'purchasing power',
          'inflation rate',
          'cost of living',
          'inflation impact',
          'future value',
          'price increase',
          'inflation projection',
          'monetary value',
          'economic calculator'
        ]}
      />
      <InflationCalculator />
      <FAQ faqs={faqs} />
    </>
  );
};

export default InflationPage;